import Lottie from 'lottie-react';
import aiIconData from '@/assets/lottie/ai-icon.json';

interface AIIconProps {
  size?: number;
  className?: string;
  /** When true, renders only the first frame (no animation). Use for small avatars. */
  static?: boolean;
}

export function AIIcon({ size = 32, className, static: isStatic }: AIIconProps) {
  return (
    <div
      className={className}
      style={{ width: size, height: size }}
    >
      <Lottie
        animationData={aiIconData}
        loop={!isStatic}
        autoplay={!isStatic}
        {...(isStatic ? { initialSegment: [0, 1] as [number, number] } : {})}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
}

export default AIIcon;
